import { actionGenerator } from '../../utils/redux/actionGenerator';
import {
  EAnswersActionTypes,
  TSetAnswerReaction,
  TSetAnswerReactionPayload,
  TSetAnswers,
  TSetAnswersPayload,
} from './types';

export const setAnswers: (payload: TSetAnswersPayload) => TSetAnswers = actionGenerator<
  EAnswersActionTypes.SetAnswers,
  TSetAnswersPayload
>(EAnswersActionTypes.SetAnswers);

export const setAnswerReactionAction: (payload: TSetAnswerReactionPayload) => TSetAnswerReaction = actionGenerator<
  EAnswersActionTypes.SetAnswerReaction,
  TSetAnswerReactionPayload
>(EAnswersActionTypes.SetAnswerReaction);
